import { WifiOff } from 'lucide-react'

export function OfflineBanner() {
  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-2 px-4 py-2 bg-warning-500 text-white text-sm font-medium"
      // iPhone 노치/Dynamic Island 영역 아래로 내용이 깔리지 않도록 safe-area 상단 패딩 적용 (갤럭시는 0px fallback)
      style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 0.5rem)' }}
    >
      <WifiOff className="w-4 h-4" />
      오프라인 상태입니다. 일부 기능이 제한될 수 있습니다.
    </div>
  )
}
